<template>
  <cube-popup
    v-show="visible"
    type="my-popup"
    :center="false"
    position="right"
    class="filter-wrap"
  >
    <div class="level-cascash-content">
      <div
        v-for=" items in teamLists"
        :key="items.value"
        class="default-item"
        @click="handleSelectLevel(items)"
      >
        <span class="text">{{ items.name }}</span>
      </div>
    </div>
  </cube-popup>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    teamLists: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleSelectLevel (val) {
      this.$emit('teamselect', val)
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-wrap::v-deep {
  .level-cascash-content {
    margin-top: 12px;
    width: 375px;
    height: 100%;
    .default-item {
      height: 48px;
      background-color: #fff;
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      .text {
        width: 64px;
        height: 48px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 48px;
        text-align: left;
        margin-left: 12px;
      }
    }
  }
}
</style>
